import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: "J'ai zéro temps.",
    answer: '10 minutes de préparation. Moins de temps que de chercher une place de parking au centre commercial.'
  }, {
    question: "C'est cher en ingrédients ?",
    answer: 'Non. Fraises fraîches + chocolat à pâtisser de ton épicerie habituelle. Budget total : environ 12–15$.'
  }, {
    question: "C'est quoi exactement ?",
    answer: "Un pack digital HD. Tu reçois ton lien d'accès 30 secondes après ton paiement. Consultable sur ton téléphone, tablette ou ordi."
  }, {
    question: 'Et si je rate ?',
    answer: "La méthode Magic Pattern est conçue pour être infaillible. Mais si jamais tu n'es pas satisfaite, je te rembourse. Point final."
  }, {
    question: "C'est pour offrir ou pour moi ?",
    answer: "Les deux. Certaines filles apprennent pour faire un cadeau. D'autres le font pour elles et leur famille. Les deux sont parfaitement valides."
  }];
  return <section className="py-10 md:py-16 px-4 md:px-8 bg-cream" data-id="element-68">
      <div className="max-w-4xl mx-auto" data-id="element-69">
        <h2 className="font-playfair text-2xl sm:text-3xl md:text-5xl font-bold text-burgundy text-center mb-2 md:mb-4" data-id="element-70">
          Tes questions.
        </h2>
        <p className="font-playfair text-lg sm:text-2xl md:text-3xl text-rose-gold text-center mb-6 md:mb-12" data-id="element-71">
          Mes réponses directes.
        </p>

        <div className="space-y-3 md:space-y-4" data-id="element-72">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-lg md:rounded-xl shadow-md overflow-hidden" data-id="element-73">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-4 py-3.5 md:px-6 md:py-5 flex items-center justify-between text-left hover:bg-blush/30 transition-colors" data-id="element-74">
                <span className="font-playfair text-base sm:text-lg md:text-xl font-semibold text-burgundy pr-3" data-id="element-75">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-76">
                  <ChevronDownIcon className="w-5 h-5 md:w-6 md:h-6 text-rose-gold flex-shrink-0" data-id="element-77" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-78">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-79">
                    <div className="px-4 pb-4 md:px-6 md:pb-5 text-gray-700 font-lato text-sm sm:text-base md:text-lg leading-relaxed" data-id="element-80">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}